import api from './index'
import { axios } from '@/utils/request'

export function addDiagnose (params) {
  return axios({
    url: api.AddDiagnose,
    method: 'post',
    params: params
  })
}

export function getDiagnoseList (params) {
  return axios({
    url: api.DiagnoseList,
    method: 'get',
    params: params
  })
}

export function getDiagnoseResult (diagnose_uid) {
  return axios({
    url: api.DiagnoseResult,
    method: 'get',
    params: { diagnose_uid: diagnose_uid }
  })
}

export function deleteDiagnose (diagnose_uid) {
  return axios({
    url: api.DeleteDiagnose + '/' + diagnose_uid,
    method: 'delete'
  })
}
